<div class="soc-search-wrapper">
    <div *ngIf="label" class="soc-search-info-wrapper">
        <label class="soc-input-lbl w-100 text-start">{{label}}</label>
    </div>
    <div class="p-inputgroup soc-search-field-wrapper">
        <i class="pi pi-search soc-neutral-text-color"></i>
        <input type="text" class="soc-search-input-field soc-input-text" [disabled]="disabled" [(ngModel)]="input" (ngModelChange)="inputChange.emit(input)" [placeholder]="placeholder" (input)="input" >
    </div>
</div>